import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { graphql } from "gatsby";
import { PrismicRichText } from "@prismicio/react";

const Holder = styled.div``;

const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    margin: 2rem 0;
    grid-gap: 1rem;

  @media (${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }

`;

const ImageHolder = styled.div`
    color: #404040;
    p {
    ${(props) => props.theme.fluidType(-2)}
    }
`;

const Image = styled.image`
`;

const SliceTwoImage = ({ slice }) => {
  const imageLeft = slice.primary.image_left.gatsbyImageData;
  const altLeft = slice.primary.image_left.alt;
  const captionLeft = slice.primary.caption_left.richText;
  const imageRight = slice.primary.image_left.gatsbyImageData;
  const altRight = slice.primary.image_right.alt;
  const captionRight = slice.primary.caption_right.richText;

  return (
    <Holder>
        <TwoColumnGrid>
          <ImageHolder>
            <Image>
              <GatsbyImage alt={altLeft || ""} image={imageLeft} />
            </Image>
            <PrismicRichText field={captionLeft} />
          </ImageHolder>
          <ImageHolder>
            <GatsbyImage alt={altRight || ""} image={imageRight} />
            <PrismicRichText field={captionRight} />
          </ImageHolder>
        </TwoColumnGrid>
    </Holder>
  );
};

SliceTwoImage.propTypes = {
  slice: PropTypes.object.isRequired,
};

export default SliceTwoImage;

export const query = graphql`
  fragment SliceTwoImage on PrismicPerspectiveDataBodyTwoImage {
    id
    slice_type
    primary {
            caption_left {
              richText
            }
            caption_right {
              richText
            }
            image_left {
              alt
              gatsbyImageData
            }
            image_right {
              alt
              gatsbyImageData
            }
          }
        }
`;
